module.exports = __webpack_public_path__ + "img/modal_icon.171fee97.svg";